import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { nextTab } from '@common-reducers/CampaignReducer';
import { useAppDispatch } from '@common-reducers/hooks/store.hook';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
import { namespace } from '@common-config/constants';
import { useIsMobile } from '@common/hooks/use-is-mobile';

type Props = {
    isDisabled: boolean;
    className?: string;
}

export default function NextTabButton({
    isDisabled,
    className,
}: Props) {
    const dispatch = useAppDispatch()
    const { t, i18n } = useTranslation(namespace);
    const isRtl = i18n.dir(i18n.resolvedLanguage || i18n.language) === 'rtl';
    const isMobile = useIsMobile();
    const handleClickNextTabButton = () => {
        dispatch(nextTab());
    }

    return (
        <div className={cn(
            "relative z-10 flex items-center justify-center",
            isDisabled && "opacity-50",
            className
        )}>
            <Button
                onClick={handleClickNextTabButton}
                disabled={isDisabled}
                className={cn(
                    isMobile ? "min-w-[140px]" : "min-w-[250px]",
                    "px-4 py-2 rounded-lg",
                    "text-white dark:text-white",
                    "disabled:opacity-50 disabled:cursor-not-allowed"
                )}
                style={{
                    background: "linear-gradient(66.67deg, #259ae9 0%, #6dd1f1 100%)"
                }}
            >
                <span className="inline-flex items-center">
                    {t('common.next')}
                    {isRtl ? (
                        <ChevronLeft className="ms-1.25 h-3.5 w-3.5" />
                    ) : (
                        <ChevronRight className="ms-1.25 h-3.5 w-3.5" />
                    )}
                </span>
            </Button>
        </div>
    )
}
